import { render, staticRenderFns } from "./ShowImageDialog.vue?vue&type=template&id=1155c2df&scoped=true"
import script from "./ShowImageDialog.vue?vue&type=script&lang=js"
export * from "./ShowImageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155c2df",
  null
  
)

export default component.exports